import { useState } from 'react';
import clsx from 'clsx';
import { useCan } from '@/app/casl/AbilityContext';
import { RESOURCES } from '@/app/casl/resources';
import MetronicCard from '@/app/components/layout/MetronicCard';
import PageShell from '@/app/components/layout/PageShell';
import ManagedAnnouncementsTab from '@/app/pages/notifications/announcements/components/ManagedAnnouncementsTab';
import ReceivedAnnouncementsTab from '@/app/pages/notifications/announcements/components/ReceivedAnnouncementsTab';
import { AnnouncementsTab } from '@/app/pages/notifications/announcements/core/_models';

type TabOption = {
  value: AnnouncementsTab;
  label: string;
};

const TABS: TabOption[] = [
  { value: AnnouncementsTab.RECEIVED, label: 'Recebidos' },
  { value: AnnouncementsTab.MANAGED, label: 'Criados' },
];

// Sem migalhas: contador e gestor também abrem esta tela, e para eles o Dashboard do sistema não existe.
const AnnouncementListPage = () => {
  const canManage = useCan(RESOURCES.PUBLICAR_COMUNICADOS);
  const [tab, setTab] = useState<AnnouncementsTab>(AnnouncementsTab.RECEIVED);
  const showsManaged = canManage && tab === AnnouncementsTab.MANAGED;
  const tabNavigation = canManage ? (
    <div
      className="nav nav-tabs nav-line-tabs my-5 fs-6 flex-nowrap overflow-auto"
      role="tablist"
      style={{ paddingBottom: '1px' }}
    >
      {TABS.map((option) => (
        <div key={option.value} className="nav-item">
          <button
            aria-selected={tab === option.value}
            className={clsx(
              'nav-link bg-transparent text-nowrap',
              tab === option.value && 'active fw-bold text-gray-600',
            )}
            role="tab"
            type="button"
            onClick={() => setTab(option.value)}
          >
            {option.label}
          </button>
        </div>
      ))}
    </div>
  ) : null;

  return (
    <PageShell title="Comunicados">
      <MetronicCard className="card-flush shadow-none border">
        <div className="card-body">
          {showsManaged ? (
            <ManagedAnnouncementsTab>{tabNavigation}</ManagedAnnouncementsTab>
          ) : (
            <ReceivedAnnouncementsTab>{tabNavigation}</ReceivedAnnouncementsTab>
          )}
        </div>
      </MetronicCard>
    </PageShell>
  );
};

export default AnnouncementListPage;
